<template>
  <div>
    <div class="row ">
      <div class="col-12 col-md-6">
        <label :style="isEditable ? 'display:none;' : ''" class="form-label">{{ label }}</label>
          <button
              class="btn btn-outline-primary btn-sm customer-edit-button"
              @click="setEditable"
              :style="isEditable ? 'display:none;' : ''"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-boundary="window"
              title="Edit the label shown in Public for this particular service."
          >
              <i class="bi bi-pen-fill"></i>
          </button>
          <div :style="isEditable ? 'display:flex; align-items: center; justify-content: justify-between' : 'display:none;'">
              <div class="col-7">
                  <input
                      class="form-control"
                      v-model="label"
                      name="included_label"
                      :type="isEditable ? 'text' : 'hidden'"
                  >
              </div>
              <div class="col-1"></div>
              <div class="col-4">
                  <svg class="accept" style="cursor: pointer; margin-right: 0.5rem" @click="setEditable" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                      <path style="fill:none;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke:grey;stroke-opacity:1;stroke-miterlimit:4" d="m7 13 4 3 7-7"/>
                      <path style="fill:none;stroke-width:2;stroke-linecap:butt;stroke-linejoin:miter;stroke:grey;stroke-opacity:1;stroke-miterlimit:4" d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm0 0"/>
                  </svg>
                  <svg class="decline" style="cursor: pointer" @click="resetLabel" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                      <path style="fill-rule:nonzero;fill:grey;fill-opacity:1;stroke-width:1.05103;stroke-linecap:round;stroke-linejoin:round;stroke:grey;stroke-opacity:1;stroke-miterlimit:4" d="M301-13a316 316 0 0 0 0 631 316 316 0 0 0 0-631Zm0 84c128 0 231 103 231 232a231 231 0 1 1-463 0C69 174 172 71 301 71Zm0 0" transform="matrix(.03807 0 0 .03805 1 0)"/>
                      <path style="fill-rule:nonzero;fill:grey;fill-opacity:1;stroke-width:1.05103;stroke-linecap:round;stroke-linejoin:round;stroke:grey;stroke-opacity:1;stroke-miterlimit:4" d="M416 145c-11 0-22 4-30 12L155 389a42 42 0 1 0 60 59l231-231a42 42 0 0 0-30-72Zm0 0" transform="matrix(.03807 0 0 .03805 1 0)"/>
                      <path style="fill-rule:nonzero;fill:grey;fill-opacity:1;stroke-width:1.05103;stroke-linecap:round;stroke-linejoin:round;stroke:grey;stroke-opacity:1;stroke-miterlimit:4" d="M185 145a42 42 0 0 0-30 72l231 231a42 42 0 0 0 60-59L215 157c-8-8-19-12-30-12Zm0 0" transform="matrix(.03807 0 0 .03805 1 0)"/>
                  </svg>
              </div>
          </div>
      </div>
    </div>
    <div v-if="this.included_services" class="row mt-2" v-for="(service,index) in this.included_services">
      <div class="col-10">
        <textarea class="form-control"
                  placeholder="Product Description"
                  rows="2" v-model="service.description" name="included[]" maxlength="70"
                  @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
                  @input='charCount(event, index)'
                  ></textarea>
      <div class="note text-medium-gray"><strong>{{ maxChars[index] }}</strong> {{ $t('chars remaining') }}</div>
      </div>
      <div class="col-2 d-flex justify-content-center">
        <a class="btn btn-square btn-danger rounded-circle" @click="removeService(index)">
            <span class="svg-icon">
                <i class="bi bi-archive-fill"></i>
            </span>
        </a>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-2">
        <button type="button" class="btn btn-custom-primary" @click="addService">New
        </button>
      </div>
    </div>
  </div>
</template>

<script>

const maxWhatsIncluded = 70;

export default {
  props: {
    old: Array,
    oldLabel: String,
    defaultLabel: String
  },
  components: {}
  ,
  data: function () {
    return {
      maxWhatsAdded: maxWhatsIncluded,
      included_services: [],
      maxChars: [],
      isEditable: false,
      label: '',
    }
  },
  methods: {
    addService() {
      this.included_services.push({
        id: this.included_services.length + 1,
        description: ''
      });
      this.maxChars[this.maxChars.length] = this.maxWhatsAdded;
    },
      charCount: function(e, index){
          var evt = e || window.event;
          this.maxChars[index] = this.maxWhatsAdded - evt.target.value.length;
          this.maxChars[index] = this.maxChars[index] < 0 ? 0 : this.maxChars[index];
      },
    removeService(index) {
      this.included_services.splice(index, 1);
      this.maxChars.splice(index, 1);
    },
    setEditable(e) {
        e.preventDefault()
        this.isEditable =!this.isEditable;
        if (this.label.length === 0) {
            this.label = this.oldLabel
        }
    },
    resetLabel(e) {
        e.preventDefault()
        this.isEditable = !this.isEditable;
        this.label = this.oldLabel
    },
  },
  mounted() {

    if (this.old.length !== 0) {
      this.included_services = [];//empty array

      let index = 0;
      this.old.forEach(
          el => {
              this.included_services.push({description: el});
              this.maxChars[index] = this.maxWhatsAdded - this.included_services[index].description.length;
              this.maxChars[index] = this.maxChars[index] < 0 ? 0 : this.maxChars[index];
              index++;
          }
      );

    } else {
        this.maxChars = [];
        this.maxChars[0] = this.maxWhatsAdded;
    }
    if (this.oldLabel) {
      this.label = this.oldLabel;
    }
      setTimeout(function (){
          var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
              return new bootstrap.Tooltip(tooltipTriggerEl)
          })
      }, 1000);
  }
}
</script>

<style scoped>
.customer-edit-button {
    padding: 0.2rem 0.4rem;
    margin-left: 0.5rem;
    border-color: grey;
}

.customer-edit-button i {
    color: grey;
}

.customer-edit-button:hover,
.customer-edit-button:hover i {
    color: #FFF;
    background-color: #3DC5D6;
    border-color: #3DC5D6;
}

.accept:hover path {
    stroke: #3dc5d6 !important;
}
.decline:hover path {
    stroke: #e24040 !important;
    fill: #e24040 !important;
}

.tooltip.top {
    margin-left: 0.5rem;
}

</style>

